import React from "react";
import injectSheet from "react-jss";

const styles = ({ theme }) => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      border: `1px dashed ${theme.colors.senary4}`,
      color: theme.colors.senary2,
      padding: theme.padding.md,
      borderRadius: theme.borderRadius.default
    }
  };
};
const EmptyScreen = ({ classes }) => {
  return <div className={classes.root} />;
};

EmptyScreen.defaultProps = {
  title: "Listan är tom"
};

export default injectSheet(styles)(EmptyScreen);
